import { NgModule } from "@angular/core";
import { AdminMenuWrapperComponent } from "./wrappers/admin-menu-wrapper/admin-menu-wrapper.component";
import { CommonModule, DatePipe, NgOptimizedImage } from "@angular/common";
import { AdminSharedRoutingModule } from "./admin-shared-routing.module";
import { AdminMenuDesktopComponent } from "./components/admin-menu-desktop/admin-menu-desktop.component";
import { AdminPageHeaderComponent } from "./components/admin-page-header/admin-page-header.component";
import { MatButtonModule } from "@angular/material/button";
import { SearchInputComponent } from "./components/search-input/search-input.component";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TableSkeletonComponent } from "./components/table-skeleton/table-skeleton.component";
import {
  AdminMenuSectionComponent
} from "./components/admin-menu-desktop/admin-menu-section/admin-menu-section.component";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { EditorComponent } from "@tinymce/tinymce-angular";
import { DeliveryTrackingComponent } from "./components/delivery-tracking/delivery-tracking.component";
import { DocumentEditorComponent } from "./components/document-editor/document-editor.component";
import { PagesSkeletonComponent } from "./components/pages-skeleton/pages-skeleton.component";
import { TranslateModule } from "@ngx-translate/core";
import { ManageHardwareDialog } from "./dialogs/manage-hardware/manage-hardware.dialog";
import { HardwareFormComponent } from "./components/hardware-form/hardware-form.component";
import { SharedModule } from "../../../shared/shared.module";
import { MatSelectModule } from "@angular/material/select";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatTooltipModule } from "@angular/material/tooltip";
import { AdminOnboardingAddressPage } from "./pages/admin-onboarding/address/admin-onboarding-address.page";
import {
  AdminOnboardingPaymentErrorPage
} from "./pages/admin-onboarding/payment-error/admin-onboarding-payment-error.page";
import {
  AdminOnboardingPaymentSuccessPage
} from "./pages/admin-onboarding/payment-success/admin-onboarding-payment-success.page";
import {
  AdminOnboardingPaymentProcessingPage
} from "./pages/admin-onboarding/payment-processing/admin-onboarding-payment-processing.page";
import {
  AdminOnboardingSubscriptionPage
} from "./pages/admin-onboarding/subscription/admin-onboarding-subscription.page";
import { AdminOnboardingSummaryPage } from "./pages/admin-onboarding/summary/admin-onboarding-summary.page";
import { AdminOnboardingProfilePage } from "./pages/admin-onboarding/profile/admin-onboarding-profile.page";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatProgressBarModule } from "@angular/material/progress-bar";


@NgModule({
  declarations: [
    AdminMenuWrapperComponent,
    AdminMenuSectionComponent,
    AdminMenuDesktopComponent,
    AdminPageHeaderComponent,
    SearchInputComponent,
    TableSkeletonComponent,
    DeliveryTrackingComponent,
    DocumentEditorComponent,
    DeliveryTrackingComponent,
    DeliveryTrackingComponent,
    PagesSkeletonComponent,
    HardwareFormComponent,
    ManageHardwareDialog,
    AdminOnboardingAddressPage,
    AdminOnboardingPaymentSuccessPage,
    AdminOnboardingPaymentErrorPage,
    AdminOnboardingPaymentProcessingPage,
    AdminOnboardingSubscriptionPage,
    AdminOnboardingProfilePage,
    AdminOnboardingSummaryPage

  ],
  exports: [
    AdminPageHeaderComponent,
    SearchInputComponent,
    TableSkeletonComponent,
    DocumentEditorComponent,
    DeliveryTrackingComponent,
    PagesSkeletonComponent
  ],
  imports: [
    CommonModule,
    AdminSharedRoutingModule,
    NgOptimizedImage,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatSnackBarModule,
    EditorComponent,
    FormsModule,
    TranslateModule,
    SharedModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatSelectModule,
    SharedModule,
    TranslateModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    MatProgressBarModule
  ],
  providers: [DatePipe]
})
export class AdminSharedModule {}
